export default __webpack_public_path__ + "static/media/School Program - Class 7.40fe4dfb.jpg";